import { Navigate, Route, Routes } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavInnerToolbar as SideNavBarLayout, SingleCard } from './layouts';
import { Footer } from './components';
import dxTextBox from 'devextreme/ui/text_box';
import dxSelectBox from 'devextreme/ui/select_box';
import dxDateBox from 'devextreme/ui/date_box';
import dxNumberBox from 'devextreme/ui/number_box';
import dxDataGrid from 'devextreme/ui/data_grid';
import dxTextArea from 'devextreme/ui/text_area';
import dxTagBox from 'devextreme/ui/tag_box';
import dxButton from 'devextreme/ui/button';
import dxAutocomplete from 'devextreme/ui/autocomplete';
import EEProExternalLoginForm from './features/common/ee-pro/components/EEProExternalLoginForm';
import { ChangePasswordForm } from './features/common';
import { LiveChatWidget } from '@livechat/widget-react';
import { useAuth } from './contexts/auth';
import dxToolbar from 'devextreme/ui/toolbar';
import { useScreenSize } from './utils/media-query';
import dxTabs from 'devextreme/ui/tabs';
import dxForm from 'devextreme/ui/form';
import dxPopup from 'devextreme/ui/popup';
import { IS_DEVELOPMENT } from './config/constants';
import { useGetCompany } from './api/company';
import { BUILD_NUMBER } from './build-number';
import dxDateRangeBox from 'devextreme/ui/date_range_box';
import dxList from 'devextreme/ui/list';

export default function Content() {

    const { user } = useAuth();
    const userCompany = useGetCompany(user?.companyId);

    const screenSize = useScreenSize();
    const isSmallScreen = screenSize.isTiny || screenSize.isXSmall || screenSize.isSmall;

    let homePage = '/home';

    dxTextBox.defaultOptions({
        options: {
            stylingMode: 'outlined'
        }
    });

    dxTextArea.defaultOptions({
        options: {
            stylingMode: 'outlined',
            spellcheck: true
        }
    });

    dxSelectBox.defaultOptions({
        options: {
            stylingMode: 'outlined',
            placeholder: ''
        }
    });

    dxAutocomplete.defaultOptions({
        options: {
            stylingMode: 'outlined',
            placeholder: ''
        }
    });

    dxDateBox.defaultOptions({
        options: {
            stylingMode: 'outlined',
            useMaskBehavior: true,
            showClearButton: true,
            min: new Date('2000-01-01')
        }
    });

    dxDateRangeBox.defaultOptions({
        options: {
            stylingMode: 'outlined',
            min: new Date('2000-01-01')
        }
    });

    dxNumberBox.defaultOptions({
        options: {
            stylingMode: 'outlined'
        }
    });

    dxDataGrid.defaultOptions({
        options: {
            scrolling: {
                useNative: false,
                showScrollbar: 'always'
            },
            columnChooser: {
                width: 300
            },
            columnHidingEnabled: isSmallScreen
        }
    });

    dxList.defaultOptions({
        options: {
            showScrollbar: 'always'
        }
    });

    dxTagBox.defaultOptions({
        options: {
            stylingMode: 'outlined',
            showScrollbar: 'always'
        }
    });

    dxButton.defaultOptions({
        options: {
            stylingMode: 'contained'
        }
    });

    dxToolbar.defaultOptions({
        options: {
            multiline: isSmallScreen
        }
    });

    dxTabs.defaultOptions({
        options: {
            scrollingEnabled: !isSmallScreen,
            showScrollbar: 'always'
        }
    });

    dxForm.defaultOptions({
        options: {
            labelLocation: "left",
            showScrollbar: 'always'
        }
    });

    dxPopup.defaultOptions({
        options: {
            fullScreen: isSmallScreen
        }
    });

    return (
        <SideNavBarLayout title={appInfo.title}>
            <Routes>
                <Route
                    path='/external-login/eepro/:quoteId/:token'
                    element={
                        <SingleCard title="External Login">
                            <EEProExternalLoginForm />
                        </SingleCard>
                    }
                />
                <Route
                    path='/change-password/:token'
                    element={
                        <div style={{ "marginTop": "20px" }}>
                            <SingleCard title="Change Password">
                                <ChangePasswordForm />
                            </SingleCard>
                        </div>
                    }
                />
                {routes.map(({ path, element }) => (
                    <Route
                        key={path}
                        path={path}
                        element={element}
                    />
                ))}
                <Route
                    path='*'
                    element={<Navigate to={homePage} />}
                />
            </Routes>
            <Footer>
                Copyright © 2011-{new Date().getFullYear()} {appInfo.title} Inc. Build number: {BUILD_NUMBER}
                <br />
                All trademarks or registered trademarks are property of their
                respective owners.
            </Footer>
            <>
                {
                    !IS_DEVELOPMENT && !!userCompany.data?.liveChatLicense &&
                    <LiveChatWidget
                        license={userCompany.data?.liveChatLicense}
                    />
                }
            </>
        </SideNavBarLayout>
    );
}

